// import { Button, Grid, List, ListItem } from '@material-ui/core';
import { width } from '@mui/system';
import { Button, Checkbox, Col, DatePicker, Divider, Form, Image, Input, InputNumber, List, Row, Typography } from 'antd'
import React from 'react'
import checkImage from '../../assets/Images/checkdetails.png';
import './depositeStyle.css'
import SaveIcon from '@material-ui/icons/Save';
import LocalPrintshopIcon from '@material-ui/icons/LocalPrintshop';
import CancelIcon from '@material-ui/icons/Cancel';
import { useState } from 'react';
import { Imports } from '../../Imports';
import { useEffect } from 'react';
import moment from 'moment-timezone';
import { showSnackBar } from '../../helpers/showSnackBar';
import { getGenerator } from '../../helpers/getGenerator';
import html2canvas from 'html2canvas';
import services from '../../Services';
import { Storage } from '../../Services/storage';
import { values } from 'lodash';
import { getEmployee } from '../../Services/hr';
import { employeeStatuses } from '../../Imports/employeeStatuses';
import { getImageUrl } from '../../helpers/getImageUrl';
import { documentSubmit } from '../../helpers/api';
import { useHistory } from 'react-router-dom';
const {
    users,
    hr,
    //   Storage,
} = services;
const { Text, Title } = Typography;
const {
    styles: {
        displayNoneStyles: useStyles
    }
} = Imports;


const UpdatedDepositeForm = () => {

    const [form] = Form.useForm()
    const classes = useStyles();
    const [isPosting, setPosting] = useState(false);

    useEffect(async () => {
        let userProfile = await JSON?.parse(localStorage?.user_profile);
        let res = await hr?.getAllApplicantsByIDApplicantLogin({ id: userProfile?.id })


        let data = {
            firstName: res?.employee?.firstName || '',
            middleName: res?.employee?.middleName || '',
            lastName: res?.employee?.lastName || '',
            hireDate: res?.employee?.hireDate || new Date(),
            position: res?.position?.FullTitle || '',
            location: res?.position?.TGSLocation?.name || '',
            pay: res?.pay?.Rate || '',
            deptID: res?.employee?.jobId || ''
        }
        setUserData(data)

        form.setFieldsValue({
            // date: new Date(),
            employename: data?.firstName + " " + data?.lastName
        })
    }, [])
    const [userData, setUserData] = useState({
        firstName: '',
        middleName: '',
        lastName: '',
        hireDate: moment(new Date())?.utc()?.format("MM-DD-YYYY"),
        position: '',
        location: '',
        pay: '',
        deptID: '',
        // jobID:'',
    })


    const access = localStorage.getItem("access_jwt") || null
    const history = useHistory()

    const onFinish = async (values) => {
        documentSubmit(setPosting, null, 10, [{ height: 0, index: 0 }], access, history)
    }

    return (
        <div>
            <Row className=' align-box'  >
                <Form
                    name="basic"

                    initialValues={{
                        remember: true,
                    }}
                    form={form}
                    onFinish={onFinish}
                    // onFinishFailed={onFinishFailed}
                    autoComplete="off"

                >
                    <div className='capture'>
                        <br />
                        <br />

                        <Row className='mt-5 align-box' style={{ width: '100%' }}  >
                            <Title level={3}>  Employee Direct Deposit Enrollment Form</Title>
                        </Row>


                        <Row  >
                            <Col md={1} />
                            <Col md={18} className='borr align-box' style={{ width: '85%', padding: '20px' }}>
                                <Row style={{ textAlign: 'left!important', width: '100%' }}>
                                    <Title level={5}>Payroll Manager--please complete this section.</Title>
                                </Row>
                                <Row>


                                    <Row style={{ width: '100%' }}>
                                        <Col md={8}>


                                            <Form.Item
                                                label="Company Code"
                                                name="companycode"

                                                rules={[
                                                    {
                                                        required: false,
                                                        message: 'Please input your Company Code!',
                                                    },
                                                ]}
                                            >
                                                <Input defaultValue={'YQP'} disabled style={{ borderBottom: '1px solid black!important', border: "none", fontWeight: 'bold', color: 'black' }} />
                                            </Form.Item>

                                        </Col>
                                        <Col md={10} ca>


                                            <Form.Item
                                                label="Company Name"
                                                name="companyname"
                                                rules={[
                                                    {
                                                        required: false,
                                                        message: 'Please input your Company Name!',
                                                    },
                                                ]}
                                            >
                                                <Input defaultValue={'TRANS GLOBAL SOLUTION'} disabled style={{ borderBottom: '1px solid black!important', border: "none", fontWeight: 'bold', color: 'black' }} />
                                            </Form.Item>

                                        </Col>
                                        <Col md={6}>
                                            <Form.Item
                                                label="Date"
                                                name="date"
                                                rules={[
                                                    {
                                                        required: false,
                                                        message: 'Please input your Date!',
                                                    },
                                                ]}
                                            >
                                                {/* <Input style={{ borderBottom: '1px solid black!important' }} /> */}
                                                <DatePicker
                                                    disabled
                                                    defaultValue={moment()} format={'MM-DD-YYYY'}
                                                    style={{ fontWeight: 'bold', color: 'black!important' }}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>


                                            <Form.Item
                                                label="PayRoll Mgr.Name"
                                                name="managername"
                                                rules={[
                                                    {
                                                        required: false,
                                                        message: 'Please input your manager name!',
                                                    },
                                                ]}
                                            >
                                                <Input defaultValue={'JENNIFER MCGOUGH'} disabled style={{ borderBottom: '1px solid black!important', border: 'none', fontWeight: 'bold', color: 'black' }} />
                                            </Form.Item>

                                        </Col>
                                        <Col md={12}>


                                            <Form.Item
                                                label="Payroll Mgr. Signature"
                                                name="managersignature"
                                                rules={[
                                                    {
                                                        required: false,
                                                        message: 'Please input your Manager Signature!',
                                                    },
                                                ]}
                                            >
                                                <Input defaultValue={'Jennifer Mcgough'} disabled className="signatureClass " style={{ borderBottom: '1px solid black!important', color: 'black', border: 'none', width: 'auto', fontSize: '20px', fontWeight: 'bold', background: "transparent" }} />
                                            </Form.Item>

                                        </Col>
                                    </Row>
                                    {/* </Form> */}
                                </Row>
                            </Col>
                            <Col md={2} className="LiqForms-Container" >
                                <Row className={isPosting ? classes.DisplayNone : "FormsHeader2"}>
                                    <List>
                                        <List.Item>
                                            <Col className="FormMenuLogo"></Col>
                                        </List.Item>
                                        <List.Item>
                                            <Form.Item

                                            >
                                                <Button htmlType="submit">
                                                    <SaveIcon />
                                                </Button>
                                            </Form.Item>
                                        </List.Item>
                                        <List.Item>
                                            <Form.Item>
                                                <Button onClick={() => window.print()}>
                                                    <LocalPrintshopIcon />
                                                </Button>
                                            </Form.Item>
                                        </List.Item>
                                        <List.Item>
                                            <Form.Item>
                                                <Button onClick={() => window.close()}>
                                                    <CancelIcon />
                                                </Button>
                                            </Form.Item>
                                        </List.Item>

                                    </List>


                                </Row>


                            </Col>
                        </Row>
                        <Row className='align-box' >
                            <Text className='w-80 mt-5'>To enroll in Full Service Direct Deposit, simply fill out this form and give it to your payroll manager. Attach a voided check for
                                each checking account – not a deposit slip. If depositing to a savings account, ask your bank to give you the Routing/Transit
                                Number for your account. It isn’t always the same as the number on a savings deposit slip. This will help ensure that you are paid
                                correctly.</Text>

                            <Image src={checkImage} preview={false} className='mt-5' width={'60%'} />
                        </Row>
                        <br />
                        <br />
                        <Row className='align-box'>
                            <Row className='w-80'>
                                <Title level={5}>
                                    Important! Please read and sign before completing and submitting.
                                </Title>
                            </Row>
                            <Row className='align-box'>
                                <Text className='w-80 '>
                                    I hereby authorize my employer (hereinafter “Company”) to deposit any amounts owed me by initiating credit entries to my
                                    accounts at the financial institutions (hereinafter “Bank") indicated on this form. Further, I authorize Bank to accept and to credit
                                    any credit entries indicated by Company to my accounts. Unless prohibited by applicable law, in the event that Employer
                                    deposits funds erroneously into my account, I authorize Employer, either directly or through its payroll service provider, to debit
                                    my account for an amount not to exceed the original amount of the erroneous credit.
                                    This authorization is to remain in full force and effect until Company and Bank have received written notice from me of its
                                    termination in such time and in such manner as to afford Company and Bank reasonable opportunity to act on it.</Text>
                            </Row>
                        </Row>
                        <Row >
                            <Row className='align-box1'>

                                <Col md={10} style={{ marginLeft: '40px' }}>


                                    <Form.Item
                                        label="Employee Name"
                                        name="employename"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your username!',
                                            },
                                        ]}


                                    >

                                        <Input disabled style={{ color: 'black', borderBottom: '1px solid black!important', border: 'none', width: '500px' }} value={`${values.firstName} ${values.lastName}`} />
                                    </Form.Item>

                                </Col>
                            </Row>
                        </Row>
                        <Row className='w-80' style={{ margin: 'auto' }}>
                            <Col md={10} style={{ border: '3px solid lightblue', paddingTop: '20px', paddingRight: '10px' }}>


                                <Form.Item
                                    label="Employee Signature"
                                    name="employesignature"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input your Employee Signature!',
                                        },
                                    ]}
                                >
                                    <Input className="signatureClass " style={{ borderBottom: '1px solid black!important', border: 'none', fontSize: '16px', fontWeight: 'bold' }} />
                                </Form.Item>

                            </Col>
                            <Col md={1} />
                            <Col md={10} style={{ paddingTop: '20px' }} >


                                <Form.Item
                                    label="Date"
                                    name="date"
                                    rules={[
                                        {
                                            required: false,
                                            message: 'Please input your username!',
                                        },
                                    ]}
                                >
                                    {/* <Input style={{ borderBottom: '1px solid black!important', border: 'none' }} /> */}
                                    <DatePicker
                                        defaultValue={moment()} format={'MM-DD-YYYY'}
                                        disabled
                                    />

                                </Form.Item>

                            </Col>
                        </Row>
                        {/* <Divider className='bor-5 w-80' /> */}

                        <br />
                        <br />

                        <Row className='align-box'>
                            <Row className='w-80'>
                                <Title level={5}>
                                    Account Information
                                </Title>
                            </Row>
                            <Row className='align-box'>
                                <Text className='w-80 '>
                                    The last item must be for the remaining amount owed to you. To distribute to more accounts, please complete another form.
                                    <span style={{ fontWeight: 'bold' }}> Make sure to indicate what kind of account, along with amount to be deposited, if less than your total net paycheck.</span>
                                </Text>
                            </Row>

                            <br />
                            <br />

                            <Row className=' w-80'>
                                <Col md={24} >
                                    <Form.Item
                                        label="Bank/Name/City"
                                        name="banknamecity"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your bank!',
                                            },
                                        ]}
                                    >
                                        <Input style={{ borderBottom: '1px solid black!important' }} />
                                    </Form.Item>

                                </Col>

                            </Row>
                            <Row className=' w-80'>
                                <Col md={10} >


                                    <Form.Item
                                        label="Routing/Transit"
                                        name="route"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your Routing/Transit !',
                                            },
                                        ]}
                                    >
                                        <Input style={{ borderBottom: '1px solid black!important' }} />
                                    </Form.Item>

                                </Col>

                                <Col md={10} >


                                    <Form.Item
                                        label="Account Number"
                                        name="accountnumber"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your accountnumber!',
                                            },
                                        ]}
                                    >
                                        <Input style={{ borderBottom: '1px solid black!important' }} />
                                    </Form.Item>

                                </Col>



                            </Row>

                            <Row className=' w-80'>
                                <Col md={3} >


                                    <Form.Item
                                        // label="Routing/Transit"
                                        name="checking"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'fill it!',
                                            },
                                        ]}
                                    >
                                        <Checkbox>Checking</Checkbox>
                                    </Form.Item>

                                </Col>

                                <Col md={2} >


                                    <Form.Item
                                        // label="Routing/Transit"
                                        name="savings"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Fill it',
                                            },
                                        ]}
                                    >
                                        <Checkbox>savings</Checkbox>
                                    </Form.Item>
                                </Col>
                                <Col md={2} >


                                    <Form.Item

                                        name="other"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Fill it',
                                            },
                                        ]}
                                    >
                                        <Checkbox>other</Checkbox>
                                    </Form.Item>
                                </Col>
                                <Col md={6} >


                                    <Form.Item
                                        label="I wish to deposit $"
                                        name="amount"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your amount!',
                                            },
                                        ]}
                                    >
                                        <InputNumber type='number' style={{ borderBottom: '1px solid black!important' }} />
                                    </Form.Item>

                                </Col>
                                <Col md={5} >


                                    <Form.Item
                                        // label="Routing/Transit"
                                        name="other"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your other!',
                                            },
                                        ]}
                                    >
                                        <Checkbox>or entire net amount or </Checkbox>
                                    </Form.Item>
                                </Col>
                                <Col md={4} >


                                    <Form.Item
                                        label="%"
                                        name="amount1"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your amount!',
                                            },
                                        ]}
                                    >
                                        <InputNumber type='number' style={{ borderBottom: '1px solid black!important' }} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Row>

                        <Row className='align-box'>

                            <Row className=' w-80'>
                                <Col md={24} >


                                    <Form.Item
                                        label="Bank/Name/City"
                                        name="bankcityname2"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your username!',
                                            },
                                        ]}
                                    >
                                        <Input style={{ borderBottom: '1px solid black!important' }} />
                                    </Form.Item>

                                </Col>

                            </Row>
                            <Row className=' w-80'>
                                <Col md={10} >


                                    <Form.Item
                                        label="Routing/Transit"
                                        name="routing/transit2"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your username!',
                                            },
                                        ]}
                                    >
                                        <Input style={{ borderBottom: '1px solid black!important' }} />
                                    </Form.Item>

                                </Col>

                                <Col md={10} >


                                    <Form.Item
                                        label="Account Number"
                                        name="accountnumber2"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your username!',
                                            },
                                        ]}
                                    >
                                        <Input style={{ borderBottom: '1px solid black!important' }} />
                                    </Form.Item>

                                </Col>



                            </Row>

                            <Row className=' w-80'>
                                <Col md={3} >


                                    <Form.Item
                                        // label="Routing/Transit"
                                        name="checking2"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your checking!',
                                            },
                                        ]}
                                    >
                                        <Checkbox>Checking</Checkbox>
                                    </Form.Item>

                                </Col>

                                <Col md={2} >


                                    <Form.Item
                                        // label="Routing/Transit"
                                        name="savings2"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your savings!',
                                            },
                                        ]}
                                    >
                                        <Checkbox>savings</Checkbox>
                                    </Form.Item>
                                </Col>
                                <Col md={2} >


                                    <Form.Item
                                        // label="Routing/Transit"
                                        name="other2"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your other!',
                                            },
                                        ]}
                                    >
                                        <Checkbox>other</Checkbox>
                                    </Form.Item>
                                </Col>
                                <Col md={6} >


                                    <Form.Item
                                        label="I wish to deposit $"
                                        name="amount3"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your amount!',
                                            },
                                        ]}
                                    >
                                        <InputNumber type='number' style={{ borderBottom: '1px solid black!important' }} />
                                    </Form.Item>

                                </Col>
                                <Col md={5} >


                                    <Form.Item
                                        // label="Routing/Transit"
                                        name="other3"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your other!',
                                            },
                                        ]}
                                    >
                                        <Checkbox>or entire net amount or </Checkbox>
                                    </Form.Item>
                                </Col>
                                <Col md={4} >


                                    <Form.Item
                                        label="%"
                                        name="amount5"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your amount !',
                                            },
                                        ]}
                                    >
                                        <InputNumber type='number' style={{ borderBottom: '1px solid black!important' }} />
                                    </Form.Item>

                                </Col>



                            </Row>



                            <Row className=' w-80'>
                                <Col md={24} >


                                    <Form.Item
                                        label="Bank/Name/City"
                                        name="banknamecity3"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your Bank Name!',
                                            },
                                        ]}
                                    >
                                        <Input style={{ borderBottom: '1px solid black!important' }} />
                                    </Form.Item>

                                </Col>

                            </Row>
                            <Row className=' w-80'>
                                <Col md={10} >


                                    <Form.Item
                                        label="Routing/Transit"
                                        name="routing3"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your Routing!',
                                            },
                                        ]}
                                    >
                                        <Input style={{ borderBottom: '1px solid black!important' }} />
                                    </Form.Item>

                                </Col>

                                <Col md={10} >


                                    <Form.Item
                                        label="Account Number"
                                        name="Accountnumber"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your Account Number!',
                                            },
                                        ]}
                                    >
                                        <Input style={{ borderBottom: '1px solid black!important' }} />
                                    </Form.Item>

                                </Col>



                            </Row>

                            <Row className=' w-80'>
                                <Col md={3} >


                                    <Form.Item
                                        // label="Routing/Transit"
                                        name="checking"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your checking !',
                                            },
                                        ]}
                                    >
                                        <Checkbox>Checking</Checkbox>
                                    </Form.Item>

                                </Col>

                                <Col md={2} >


                                    <Form.Item
                                        // label="Routing/Transit"
                                        name="savings4"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your saving!',
                                            },
                                        ]}
                                    >
                                        <Checkbox>savings</Checkbox>
                                    </Form.Item>
                                </Col>
                                <Col md={2} >


                                    <Form.Item
                                        // label="Routing/Transit"
                                        name="other4"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your other!',
                                            },
                                        ]}
                                    >
                                        <Checkbox>other</Checkbox>
                                    </Form.Item>
                                </Col>
                                <Col md={6} >


                                    <Form.Item
                                        label="I wish to deposit $"
                                        name="amount4"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your amount!',
                                            },
                                        ]}
                                    >
                                        <InputNumber type='number' style={{ borderBottom: '1px solid black!important' }} />
                                    </Form.Item>

                                </Col>
                                <Col md={5} >


                                    <Form.Item
                                        // label="Routing/Transit"
                                        name="other4"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your other!',
                                            },
                                        ]}
                                    >
                                        <Checkbox>or entire net amount or </Checkbox>
                                    </Form.Item>
                                </Col>
                                <Col md={4} >


                                    <Form.Item
                                        label="%"
                                        name="amount0"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please input your username!',
                                            },
                                        ]}
                                    >
                                        <InputNumber type='number' style={{ borderBottom: '1px solid black!important' }} />
                                    </Form.Item>

                                </Col>



                            </Row>
                        </Row>

                        <Row className='align-box'>
                            <Row className='w-80'>
                                <Title level={5}>
                                    ATTENTION PAYROLL MANAGER:
                                </Title>
                            </Row>
                            <Row className='w-80' style={{ marginBottom: '20px' }}>
                                <Text style={{ fontWeight: 'bold', fontSize: '12px' }}>
                                    Employers must keep each original employee enrollment form on file as long as the employee is using FSDD, and for two years there after
                                </Text>
                            </Row>
                        </Row>
                        <br />
                        <br />
                    </div>
                </Form>
            </Row>

        </div>
    )
}

export default UpdatedDepositeForm